import { AsyncPipe } from "@angular/common";
import { ChangeDetectionStrategy, Component } from "@angular/core";
import { ToastKind, ToastService } from "../../toast.service";

@Component({
  selector: 'dxc-toaster',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './toaster.component.html',
  styleUrls: ['./toaster.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ToasterComponent {

  readonly icons: Record<ToastKind, string> = {
    success: 'fas fa-check-circle',
    error: 'fas fa-exclamation-circle',
    info: 'fas fa-info-circle',
    warning: 'fas fa-exclamation-triangle'
  };

  constructor(public readonly toasts: ToastService) { }
}
